import { c as _c } from "react/compiler-runtime";
// Позиция заявки на возврат (макет «Профиль», деталь заявки): слева карточка
// #F8F8F8 r20 300×149 — фото 100×133 r16 с оранжевым чекбоксом, цена 14/700,
// бренд 14, название+вариант 12 (48 %), счётчик #ECECEC r8 или «N шт.»;
// справа — «Причина», «Сумма к возврату», «Детали возврата» (медиа 50×66 r4)
// и комментарий 14/18.
import { RETURN_REASON_LABEL, type ReturnAttachment, type ReturnLine } from "@/api";
import { useFormatPrice } from "@/lib/use-format-price";
import { MediaStrip, OrangeCheck, ProductTile, QtyStepper } from "./return-parts";
export function ReturnLineCard(t0) {
  const $ = _c(58);
  const {
    line,
    brand,
    media,
    selectable,
    showCheck: t1,
    selected,
    onSelect,
    cancelQty,
    onCancelQty
  } = t0;
  const showCheck = t1 === undefined ? true : t1;
  const fmt = useFormatPrice();
  let t2;
  if ($[0] !== onSelect || $[1] !== selectable || $[2] !== selected || $[3] !== showCheck) {
    t2 = showCheck ? <span className="absolute top-0 left-0"><OrangeCheck checked={selected} onChange={selectable ? onSelect : undefined} disabled={!selectable} label={selected ? "\u041F\u043E\u0437\u0438\u0446\u0438\u044F \u0432\u044B\u0431\u0440\u0430\u043D\u0430" : "\u0412\u044B\u0431\u0440\u0430\u0442\u044C \u043F\u043E\u0437\u0438\u0446\u0438\u044E"} /></span> : null;
    $[0] = onSelect;
    $[1] = selectable;
    $[2] = selected;
    $[3] = showCheck;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== line.photo || $[6] !== t2) {
    t3 = <ProductTile src={line.photo}>{t2}</ProductTile>;
    $[5] = line.photo;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== fmt || $[9] !== line.unitPrice) {
    t4 = fmt(line.unitPrice);
    $[8] = fmt;
    $[9] = line.unitPrice;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t4) {
    t5 = <span className="text-[14px] leading-[14px] font-bold tracking-[-0.42px] text-[#333]">{t4}</span>;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== brand) {
    t6 = brand ? <span className="mt-2 truncate text-[14px] leading-[15px] font-semibold tracking-[-0.28px] text-ds-ink">{brand}</span> : null;
    $[13] = brand;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== line.name || $[16] !== line.variant) {
    t7 = [line.name, line.variant].filter(Boolean);
    $[15] = line.name;
    $[16] = line.variant;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  const t8 = t7.join(", ");
  let t9;
  if ($[18] !== t8) {
    t9 = <span className="mt-1 line-clamp-2 text-[12px] leading-4 font-medium tracking-[-0.24px] text-[#797979]">{t8}</span>;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== cancelQty || $[21] !== line.quantity || $[22] !== onCancelQty || $[23] !== selectable) {
    t10 = selectable && onCancelQty && line.quantity > 1 ? <QtyStepper className="mt-auto self-start" value={cancelQty ?? line.quantity} max={line.quantity} onChange={onCancelQty} /> : selectable && line.quantity === 1 ? <QtyStepper className="mt-auto self-start" value={1} max={1} /> : <span className="mt-auto text-[12px] leading-4 font-medium tracking-[-0.24px] text-[#797979]">{line.quantity} шт.</span>;
    $[20] = cancelQty;
    $[21] = line.quantity;
    $[22] = onCancelQty;
    $[23] = selectable;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== t10 || $[26] !== t5 || $[27] !== t6 || $[28] !== t9) {
    t11 = <div className="flex min-w-0 flex-1 flex-col">{t5}{t6}{t9}{t10}</div>;
    $[25] = t10;
    $[26] = t5;
    $[27] = t6;
    $[28] = t9;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  let t12;
  if ($[30] !== t11 || $[31] !== t3) {
    t12 = <div className="flex h-[149px] w-full shrink-0 gap-3 rounded-[20px] bg-[#F8F8F8] p-2 md:w-[300px]">{t3}{t11}</div>;
    $[30] = t11;
    $[31] = t3;
    $[32] = t12;
  } else {
    t12 = $[32];
  }
  let t13;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <span className="font-semibold">Причина</span>;
    $[33] = t13;
  } else {
    t13 = $[33];
  }
  const t14 = RETURN_REASON_LABEL[line.reasonCode] ?? line.reasonCode;
  let t15;
  if ($[34] !== t14) {
    t15 = <p className="text-[14px] leading-[18px] text-ds-primary">{t13}<span className="ml-2">{t14}</span></p>;
    $[34] = t14;
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  let t16;
  if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <span className="font-semibold">Сумма к возврату</span>;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  let t17;
  if ($[37] !== fmt || $[38] !== line.refund) {
    t17 = fmt(line.refund);
    $[37] = fmt;
    $[38] = line.refund;
    $[39] = t17;
  } else {
    t17 = $[39];
  }
  let t18;
  if ($[40] !== t17) {
    t18 = <p className="mt-1.5 text-[14px] leading-[18px] text-ds-primary">{t16}<span className="ml-2">{t17}</span></p>;
    $[40] = t17;
    $[41] = t18;
  } else {
    t18 = $[41];
  }
  let t19;
  if ($[42] !== line.comment || $[43] !== media.length) {
    t19 = media.length > 0 || line.comment ? <p className="mt-1.5 text-[14px] leading-[18px] font-semibold text-ds-primary">Детали возврата</p> : null;
    $[42] = line.comment;
    $[43] = media.length;
    $[44] = t19;
  } else {
    t19 = $[44];
  }
  let t20;
  if ($[45] !== media) {
    t20 = media.length > 0 ? <MediaStrip items={media} w={50} h={66} className="mt-2" /> : null;
    $[45] = media;
    $[46] = t20;
  } else {
    t20 = $[46];
  }
  let t21;
  if ($[47] !== line.comment) {
    t21 = line.comment ? <p className="mt-2 text-[14px] leading-[18px] whitespace-pre-line text-ds-primary">{line.comment}</p> : null;
    $[47] = line.comment;
    $[48] = t21;
  } else {
    t21 = $[48];
  }
  let t22;
  if ($[49] !== t15 || $[50] !== t18 || $[51] !== t19 || $[52] !== t20 || $[53] !== t21) {
    t22 = <div className="min-w-0 flex-1">{t15}{t18}{t19}{t20}{t21}</div>;
    $[49] = t15;
    $[50] = t18;
    $[51] = t19;
    $[52] = t20;
    $[53] = t21;
    $[54] = t22;
  } else {
    t22 = $[54];
  }
  let t23;
  if ($[55] !== t12 || $[56] !== t22) {
    t23 = <div className="flex flex-col gap-[10px] md:flex-row">{t12}{t22}</div>;
    $[55] = t12;
    $[56] = t22;
    $[57] = t23;
  } else {
    t23 = $[57];
  }
  return t23;
}